import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { ProposalService } from 'src/app/search-proposals/services/proposal.service';
import { FdSelectConfig } from 'src/app/shared/fd-form-components/fd-select/fd-select.component';

@Component({
    selector: 'app-compliance-proposal-list-filters',
    templateUrl: './compliance-proposal-list-filters.component.html',
    styleUrls: ['./compliance-proposal-list-filters.component.scss'],
    standalone: false
})
export class ComplianceProposalListFiltersComponent implements OnInit {

  @Input() parentForm: UntypedFormGroup;
  formGroup: UntypedFormGroup;
  selectedInstitution: string;
  @Input() fields: FdFieldConfigs;
  @Input() exportValid: boolean;
  @Input() historyTabActive: boolean;

  @Output() onSearch = new EventEmitter<void>();
  @Output() onExport = new EventEmitter<void>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private proposalService: ProposalService
  ) { }

  ngOnInit() {
    this.formGroup = this.parentForm;
  }


  clearFilters() {
    this.formGroup.controls.startDate.setValue('');
    this.formGroup.controls.endDate.setValue('');
    this.formGroup.controls.institution.setValue('');

    this.formGroup.controls.serviceContract.disable();
    this.formGroup.controls.serviceContract.setValue('');

    this.formGroup.controls.complianceStatus.setValue('');
    this.formGroup.controls.cpfCnpj.setValue('');

  }

  getAllProposalStatus(): void {
    this.proposalService.searchAllProposalStatus()
      .subscribe(list => {
        if (list != null) {
          (this.fields.proposalStatus as FdSelectConfig).items = [];
          (this.fields.proposalStatus as FdSelectConfig).items.push(...list);
        }
      });
    this.formGroup.controls.proposalStatus.setValue('');
  }

  changeSelectedInstitution(institution: string) {
    this.selectedInstitution = institution;
  }


  emitSearch() {
    this.onSearch.emit();
  }
  emitExport() {
    this.onExport.emit();
  }

}
